import {
  APICredentialsListResponse,
  APICredentialsResponse,
  CreateAPICredentials
} from '@cnds-types/apicredentials';

import { AxiosError, AxiosRequestConfig } from 'axios';
import { Gateway } from 'index';

import { Course, Faculty } from 'types/AppTypes';

export const getCourses = async (config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get<Course[]>('/core/v1/courses', config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getFaculties = async (config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get<Faculty[]>('/core/v1/faculties', config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export async function createAPIKey(
  credentials: Pick<CreateAPICredentials, 'name' | 'description'>,
  config?: AxiosRequestConfig
): Promise<APICredentialsResponse> {
  try {
    const response = await Gateway.post<APICredentialsResponse>(
      `/core/v1/api-keys`,
      {
        name: credentials.name,
        description: credentials.description
      },
      config
    );
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
}

export async function getAPIKeys(config?: AxiosRequestConfig): Promise<APICredentialsListResponse> {
  try {
    const response = await Gateway.get<APICredentialsListResponse>(`/core/v1/api-keys`, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
}

export async function deleteAPIKey(
  id: string,
  config?: AxiosRequestConfig
): Promise<APICredentialsListResponse> {
  try {
    const response = await Gateway.delete<APICredentialsListResponse>(
      `/core/v1/api-keys/${id}`,
      config
    );
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
}
